import { render, staticRenderFns } from "./tribeList.vue?vue&type=template&id=ce076d82&scoped=true&"
import script from "./tribeList.vue?vue&type=script&lang=js&"
export * from "./tribeList.vue?vue&type=script&lang=js&"
import style0 from "./tribeList.vue?vue&type=style&index=0&id=ce076d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce076d82",
  null
  
)

export default component.exports